module.exports = __webpack_public_path__ + "static/media/Circus Strong Man.c05f4615.jpg";